'use strict';
const urljoin = require('url-join');

const api =  {
    getSupportBaseUrl: function () {
        return 'https://help.muzzylane.com/tickets-view';
    },

    getSupportNewTicketUrl: function () {
        return urljoin(api.getSupportBaseUrl(), '/new');
    },

    getKbUrl: function() {
        return 'https://www.muzzylane.com/author-knowledge-base';
    },

    getDiscordUrl: function() {
        return 'https://discord.gg/YKSPK26naw';
    },

    getSupportUrl: function() {
        return api.getSupportBaseUrl();
    },
}

module.exports = api;